package br.com.texeratx.boardgametimeapp.core.network

import io.github.aakira.napier.Napier
import io.ktor.client.HttpClient
import io.ktor.client.engine.*
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

expect fun httpClientEngine(): HttpClientEngine

object KtorHttpClient {

    val client = HttpClient(httpClientEngine()) {
        install(ContentNegotiation) {
            json(
                Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                    prettyPrint = false
                }
            )
        }

        install(Logging) {
            logger = object : Logger {
                override fun log(message: String) {
                    // Napier -> logcat (tag: HTTP)
                    Napier.d(message = message, tag = "HTTP")
                    // Fallback: println -> logcat (tag: System.out) no Android,
                    // stdout no desktop/JS. Garante visibilidade mesmo se Napier
                    // ainda não estiver inicializado.
                    println("HTTP | $message")
                }
            }
            level = LogLevel.ALL
        }
    }
}
